<div class="content-layout left-sidebar-fullheight-basic-inner-scroll" cdkScrollable>
  <mat-drawer-container>
    <!-- Drawer -->
    <mat-drawer [autoFocus]="false" [mode]="drawerMode" [opened]="drawerOpened" #drawer>
      <calendar-sidebar
        (calendarToggled)="onCalendarToggled($event)"
        (calendarEdited)="onCalendarEdited($event)"
      ></calendar-sidebar>
    </mat-drawer>

    <mat-drawer-content>
      <!-- Main -->
      <div class="main" [ngClass]="{ 'events-loading': isEventsLoading }">
        <div class="header">
          <div class="header__left">
            <button class="drawer-toggle" mat-icon-button (click)="toggleDrawer()">
              <mat-icon [svgIcon]="'menu'"></mat-icon>
            </button>
            <h4 class="title">{{ calendarTitle }}</h4>
          </div>
          <div class="header__right">
            <!-- Previous Calendar Page -->
            <button class="mr-2" mat-icon-button [matTooltip]="'Previous'" (click)="navigateCalendarDates('prev')">
              <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
            </button>

            <!-- Go To Today Calendar -->
            <button
              class="lt-md:hidden mr-2"
              mat-icon-button
              [matTooltip]="'Today'"
              (click)="navigateCalendarDates('today')"
            >
              <mat-icon [svgIcon]="'today'"></mat-icon>
            </button>

            <!-- Next Calendar Page -->
            <button class="mr-2" mat-icon-button [matTooltip]="'Next'" (click)="navigateCalendarDates('next')">
              <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
            </button>

            <!-- Copy Calendar URL -->
            <button
              class="lt-md:hidden mr-2"
              mat-icon-button
              [matTooltip]="'Add to Google Calendar, Microsoft Outlook, Apple iPhone and other Calendars'"
              (click)="copyIcalUrl()"
            >
              <mat-icon [svgIcon]="'rss_feed'"></mat-icon>
            </button>

            <!-- Filter Button -->
            <button mat-stroked-button [matTooltip]="'Open Filter Options Dialog'" (click)="openFilterDialog()">
              <mat-icon class="icon-size-20 rotate-90 mirror mr-2" [svgIcon]="'tune'"></mat-icon>
              Filter
            </button>

            <!-- Change View/Period Button -->
            <mat-form-field class="lt-md:hidden treo-mat-dense treo-mat-no-subscript view-changer justify-self-end">
              <mat-select (selectionChange)="changeView(viewChanger.value)" [value]="view" #viewChanger="matSelect">
                <mat-option [value]="'dayGridMonth'">Month</mat-option>
                <mat-option [value]="'timeGridWeek'">Week</mat-option>
                <mat-option [value]="'timeGridDay'">Day</mat-option>
                <mat-option [value]="'listYear'">Schedule</mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Mobile Menu -->
            <button class="actions-menu hidden lt-md:inline-flex" [matMenuTriggerFor]="actionsMenu" mat-icon-button>
              <mat-icon [svgIcon]="'more_vert'"></mat-icon>
              <mat-menu #actionsMenu="matMenu">
                <button mat-menu-item (click)="navigateCalendarDates('today')">
                  <mat-icon [svgIcon]="'today'"></mat-icon>
                  <span>Go to today</span>
                </button>
                <button [matMenuTriggerFor]="actionsViewsMenu" mat-menu-item>
                  <mat-icon class="mr-2" [svgIcon]="'tune'"></mat-icon>
                  <span>View</span>
                </button>
              </mat-menu>

              <mat-menu #actionsViewsMenu="matMenu">
                <button mat-menu-item [disabled]="view === 'dayGridMonth'" (click)="changeView('dayGridMonth')">
                  <mat-icon [svgIcon]="'view_comfy'"></mat-icon>
                  <span>Month</span>
                </button>
                <button mat-menu-item [disabled]="view === 'timeGridWeek'" (click)="changeView('timeGridWeek')">
                  <mat-icon [svgIcon]="'view_week'"></mat-icon>
                  <span>Week</span>
                </button>
                <button mat-menu-item [disabled]="view === 'timeGridDay'" (click)="changeView('timeGridDay')">
                  <mat-icon [svgIcon]="'view_day'"></mat-icon>
                  <span>Day</span>
                </button>
                <button mat-menu-item [disabled]="view === 'listYear'" (click)="changeView('listYear')">
                  <mat-icon [svgIcon]="'view_agenda'"></mat-icon>
                  <span>Schedule</span>
                </button>
              </mat-menu>
            </button>
          </div>
        </div>

        <ng-container *ngIf="isEventsLoading">
          <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
        </ng-container>

        <div class="calendar">
          <full-calendar [options]="calendarOptions" #fullCalendar></full-calendar>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<!-- Event Panel -->
<ng-template #eventPanel>
  <div class="row header">
    <mat-icon [svgIcon]="'info'"></mat-icon>

    <div class="row-content">
      <div class="info">
        <h3 class="title">{{ event.title || '(No title)' }}</h3>
        <div class="date">{{ event.start | date: 'EEEE, MMMM d' }}</div>
      </div>
    </div>
  </div>
  <div class="row description" *ngIf="event.description">
    <mat-icon [svgIcon]="'work'"></mat-icon>
    <div class="row-content">{{ event.event_type === 'task' ? 'Task' : 'Key Date' }}</div>
  </div>
  <ng-container *ngIf="getEventExtendedProps(event).calendarId">
    <div class="row calendar">
      <mat-icon [svgIcon]="'domain'"></mat-icon>
      <div class="row-content">
        <a
          [routerLink]="[
            '../projects/' + getEventExtendedProps(event).calendarId + '/' + getEventExtendedProps(event).related_to_id
          ]"
          >{{ getEventExtendedProps(event).related_to_name }}</a
        >
      </div>
    </div>
  </ng-container>
  <div class="row description" *ngIf="event.description">
    <mat-icon [svgIcon]="'notes'"></mat-icon>
    <div class="row-content">{{ event.description }}</div>
  </div>
  <ng-container *ngIf="getCalendar(event)?.title">
    <div class="row calendar">
      <mat-icon [svgIcon]="'today'"></mat-icon>
      <div class="row-content">
        <div class="color" [ngClass]="getCalendar(event)?.color"></div>
        <div class="title">{{ getCalendar(event).title }}</div>
      </div>
    </div>
  </ng-container>
</ng-template>
